export const SET_FOCUSED_MESSAGE = 'SET_FOCUSED_MESSAGE';
export const SHOW_MESSAGE_PREVIEW = 'SHOW_MESSAGE_PREVIEW';
export const HIDE_MESSAGE_PREVIEW = 'HIDE_MESSAGE_PREVIEW';
export const SHOW_MESSAGE_COMPOSER = 'SHOW_MESSAGE_COMPOSER';
export const HIDE_MESSAGE_COMPOSER = 'HIDE_MESSAGE_COMPOSER';
export const SAVE_PENDING_MESSAGE = 'SAVE_PENDING_MESSAGE';
export const CLEAR_PENDING_MESSAGE = 'CLEAR_PENDING_MESSAGE';
export const CLEAR_ONE_PENDING_MESSAGE = 'CLEAR_ONE_PENDING_MESSAGE';
export const SET_COMPOSER_TYPE = 'SET_COMPOSER_TYPE';
export const SHOW_FORWARD_MODAL = 'SHOW_FORWARD_MODAL';
export const HIDE_FORWARD_MODAL = 'HIDE_FORWARD_MODAL';

export const setFocusedMessage = message => ({
  type: SET_FOCUSED_MESSAGE,
  message,
});

export const showMessagePreview = message => ({
  type: SHOW_MESSAGE_PREVIEW,
  message,
});

export const hideMessagePreview = () => ({
  type: HIDE_MESSAGE_PREVIEW,
});

export const showMessageComposer = message => ({
  type: SHOW_MESSAGE_COMPOSER,
  message,
});

export const hideMessageComposer = () => ({
  type: HIDE_MESSAGE_COMPOSER,
});

export const savePendingMessage = message => ({
  type: SAVE_PENDING_MESSAGE,
  message,
});

export const clearPendingMessage = idx => {
  if (typeof idx !== 'undefined') {
    return { type: CLEAR_ONE_PENDING_MESSAGE, idx };
  }
  return { type: CLEAR_PENDING_MESSAGE };
};

export const setComposerType = tabType => ({
  type: SET_COMPOSER_TYPE,
  tabType,
});

export const showForwardModal = (message, callback) => ({
  type: SHOW_FORWARD_MODAL,
  message,
  callback,
});

export const hideForwardModal = () => ({
  type: HIDE_FORWARD_MODAL,
});

export const editExistingForm = () => (dispatch, getState) => {
  const focusedMessage = getState().composer.focusedMessage;
  dispatch(setComposerType(focusedMessage.getMessageType()));
  dispatch(
    showMessageComposer({
      value: JSON.stringify(focusedMessage.getDisplayBody()),
      type: focusedMessage.getMessageType(),
    })
  );
};



// WEBPACK FOOTER //
// ./app/actions/ComposerActionCreators.js